import {useRef} from "react";
import {Grip, X} from "lucide-react";
import {Button} from "@/components/ui/button.tsx";
import {useTableTopSelection} from "@/tabletop/selection/TableTopSelectionHooks.ts";
import TableTopPropertiesView from "@/tabletop/TableTopPropertiesView.tsx";
import {useGameMasterViewSettings} from "@/tabletop/gm/GameMasterViewSettingsHooks.ts";
import {useFloatingPanel} from "./useFloatingPanel.ts";
import {CombatantDockLayout} from "./tokens/edit/CombatantDockLayout.tsx";
import EditNameDialog from "./tokens/edit/EditNameDialog.tsx";

export default function FloatingCombatantPropertiesPanel() {
    const {selectedCombatants, clearSelection} = useTableTopSelection();
    const {friendlyVisibility} = useGameMasterViewSettings();
    const mainPanelRef = useRef<HTMLDivElement>(null);
    const {panelRef, measure, onMoveKeyDown, headerProps, style} = useFloatingPanel(
        "diredawn.tabletop.combatant-properties.position.v1", selectedCombatants.length > 0, mainPanelRef);
    if (!selectedCombatants.length) return null;

    return <aside ref={panelRef} aria-label="Combatant-Eigenschaften"
        className="absolute z-20 flex w-fit max-h-[calc(100%-2rem)] flex-col overflow-hidden rounded-xl border bg-gray-950 text-white shadow-xl"
        style={style}>
        <div className="flex shrink-0 cursor-grab touch-none select-none items-center border-b border-white/15 active:cursor-grabbing"
            {...headerProps}>
            <div className="ml-2 flex items-center justify-center p-2"
                role="button" tabIndex={0} aria-label="Eigenschaften verschieben"
                onKeyDown={onMoveKeyDown}>
                <Grip className="size-4 shrink-0 text-white/60" aria-hidden="true"/>
            </div>
            <div className="min-w-0 flex-1 py-2 pr-2 text-lg font-semibold">
                {selectedCombatants.length === 1 ? <EditNameDialog key={selectedCombatants[0].id} combatant={selectedCombatants[0]}>
                    <button type="button" aria-label="Combatant-Namen bearbeiten" title="Combatant-Namen bearbeiten"
                        className="block max-w-full cursor-pointer truncate text-left hover:underline">
                        {selectedCombatants[0].name}
                    </button>
                </EditNameDialog> : <span>{selectedCombatants.length} Combatants</span>}
            </div>
            <Button type="button" size="icon-sm" variant="ghost" className="mr-1 text-white"
                title="Auswahl aufheben" aria-label="Auswahl aufheben" onClick={clearSelection}><X/></Button>
        </div>
        <CombatantDockLayout mainPanelRef={mainPanelRef} onLayoutChange={measure}
            combatant={selectedCombatants.length === 1 ? selectedCombatants[0] : undefined}>
            <TableTopPropertiesView visibility={friendlyVisibility}/>
        </CombatantDockLayout>
    </aside>;
}
